/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Message_RejectedInputs */

const en_sync_message_rejected = /** @type {(inputs: Sync_Message_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refused`)
};

/**
* | output |
* | --- |
* | "Refused" |
*
* @param {Sync_Message_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_message_rejected = /** @type {((inputs?: Sync_Message_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Message_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_message_rejected(inputs)
});